import { types } from '../../constants/ActionTypes'

const initialState = {
  googleMap: {
    loaded: false,
  },
  errorMessage: {
    isFetching: false,
    errorMessage: {},
    response: null,
  },
  bitly: {
    isFetching: false,
    response: null,
    shortURL: ''
  },
  twitter: {
    tweet: {
      isFetching: false,
      response: '',
    },
    getScheduleTweetList: {
      isFetching: false,
      tweetList: null,
      response: '',
    },
    deleteScheduleTweet: {
      isFetching: false,
      response: '',
    },
  },
  live: {
    socket: null,
    liveIds: [],
  }
}

const api = (state = initialState, action) => {
  var newState = Object.assign({}, state) // socketはポインタとしてコピーしたいためdeepCopyではなくassignを使う。
  switch (action.type) {
    case types.googleMap.COMPLETED_LOAD:
      return { ...state, googleMap: { ...state.googleMap, loaded: true } }
    case types.REQUEST_ERROR_MESSAGE_POST:
      return {
        ...state,
        errorMessage: {
          ...state.errorMessage,
          isFetching: true,
          errorMessage: action.errorMessage
        }
      }
    case types.RECEIVE_ERROR_MESSAGE_POST:
      return {
        ...state,
        errorMessage: {
          ...state.errorMessage,
          isFetching: true,
          errorMessage: action.errorMessage,
          response: action.response 
        }
      }
    
    // bitly
    case types.bitly.REQUEST_MAKE_SHORT_URL:
      return {
        ...state,
        bitly: {
          ...state.bitly,
          isFetching: true,
        }
      }
    case types.bitly.RECEIVE_MAKE_SHORT_URL:
      return {
        ...state,
        bitly: {
          ...state.bitly,
          isFetching: false,
          response: action.response,
        }
      }
    case types.bitly.CLEAR_SHORT_URL:
      return {
        ...state,
        bitly: {
          ...state.bitly,
          shortURL: '',
        }
      }

    // twitter
    case types.twitter.REQUEST_TWEET:
      return {
        ...state,
        twitter: {
          ...state.twitter,
          tweet: {
            ...state.twitter.tweet,
            isFetching: true,
          }
        }
      }
    case types.twitter.RECEIVE_TWEET:
      return {
        ...state,
        twitter: {
          ...state.twitter,
          tweet: {
            ...state.twitter.tweet,
            isFetching: false,
            response: action.response,
          }
        }
      }
    case types.twitter.REQUEST_GET_SCHEDULE_TWEET_LIST:
      newState.twitter.getScheduleTweetList.isFetching = true
      return newState
    case types.twitter.RECEIVE_GET_SCHEDULE_TWEET_LIST:
    newState.twitter.getScheduleTweetList.isFetching = false
    newState.twitter.getScheduleTweetList.response = action.response
      return newState
    case types.twitter.CLEAR_SCHEDULE_TWEET_LIST:
      newState.twitter.getScheduleTweetList.tweetList = null
      return newState
    case types.twitter.REQUEST_DELETE_SCHEDULE_TWEET:
      newState.twitter.deleteScheduleTweet.isFetching = true
      return newState
    case types.twitter.RECEIVE_DELETE_SCHEDULE_TWEET:
      newState.twitter.deleteScheduleTweet.isFetching = false
      newState.twitter.deleteScheduleTweet.response = action.response
      return newState
    
    // socket.io
    case types.router.LOCATION_CHANGE:
      return { ...state, socketIO: { ...state.socketIO, liveIds: [] }, } 
    case types.live.CONNECT:
      newState.live.socket = action.socket
      return newState
    case types.live.RECEIVE_LIVE_ID:
      if (newState.live.liveIds.some((liveId) => liveId === action.liveId)) {
        return state
      }
      newState.live.liveIds.push(action.liveId)
      return newState

    default:
      return state
  }
}

export default api






// WEBPACK FOOTER //
// ./src/reducers/API/Api.js